/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "house-0fc3fee8--sprite",
  "use": "house-0fc3fee8--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"house-0fc3fee8--sprite\"><g transform=\"translate(36 36) rotate(180)\"><g transform=\"translate(36 36) rotate(180)\" opacity=\"0\"><g fill=\"#fff\" stroke=\"#707070\" stroke-width=\"1\" opacity=\"0.5\"><rect width=\"36\" height=\"36\" stroke=\"none\" /><rect x=\"0.5\" y=\"0.5\" width=\"35\" height=\"35\" fill=\"none\" /></g></g></g><g transform=\"translate(-998.67 -1699.393)\"><path d=\"M1025.7,1715.373v9.52a3.2,3.2,0,0,1-3.24,3.14h-3.97v-4.1a1.216,1.216,0,0,0-1.21-1.22h-1.19a1.223,1.223,0,0,0-1.21,1.22v4.1h-3.97a3.186,3.186,0,0,1-3.24-3.14v-9.49a1.82,1.82,0,0,1,.56-1.35l7.61-7.22a1.5,1.5,0,0,1,2.11-.01l.02.02,3.4,3.41.01.01v-1.72a.713.713,0,0,1,.71-.71h1.46a.713.713,0,0,1,.71.71v4.61l.91.9A1.922,1.922,0,0,1,1025.7,1715.373Z\" fill=\"currentColor\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
